import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

const posterStyles = `
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const WebcamPoster = styled.img`
  ${posterStyles}
`;

export const WebcamPosterDynamic = styled(GatsbyImage)`
  ${posterStyles}
`;
